export const INDICATOR_SIZE = 9;
export const INDICATOR_HALF_SIZE = INDICATOR_SIZE / 2;
export const NO_COLUMNS_LIMIT = 4;
